import { useEffect, useState } from "react";

const navLinks = [
  { id: "hot", label: "今日热瓜" },
  { id: "rank", label: "吃瓜热榜" },
  { id: "follow", label: "蹲后续" },
  { id: "channels", label: "吃瓜频道" },
  { id: "community", label: "群众口碑" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_rgba(224,74,65,0.08)]"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6" aria-label="主导航">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50">
            <i className="ri-seedling-line"></i>
          </span>
          <span className="font-display text-xl leading-none text-foreground-900">
            吃瓜<span className="text-primary-500">52</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              className="rounded-full px-3 py-2 text-sm font-medium text-foreground-600 transition-colors hover:bg-primary-50 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-send-plane-line mr-1.5"></i>订阅吃瓜
          </a>
          <button
            type="button"
            aria-label="切换导航菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-foreground-200 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-foreground-100 bg-background-50 px-4 pb-4 lg:hidden">
          <div className="mt-3 flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}